import { SET_TASKS, SET_TASKS_UPDATED } from '../constants/TaskConstants';

const initialState = {
  tasks: {
    list: [],
    count: 0,
  },
  updated: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_TASKS: {
      return {
        ...state,
        tasks: {
          list: action.payload.list,
          count: action.payload.count,
        },
        updated: false,
      };
    }

    case SET_TASKS_UPDATED: {
      return {
        ...state,
        updated: action.payload,
      };
    }

    default: {
      return state;
    }
  }
}
